<template>
	<div class="add_backimg add_backimgTop clearfix">
		<div class="center_head">
			<img src="@/images/center_headBack.png" class="center_headBack" />
			<div class="center_headCont">
				<div class="center_headLeft">
					<div class="center_headIcon">
						<img :src="baseurl + userinfo.iconurl" v-if="userinfo.iconurl" />
						<img src="@/images/1.png" v-else />
					</div>
					<div class="center_headName">{{userinfo.name}}</div>
					<div class="center_headUsername">学号：{{userinfo.username}}</div>
				</div>
				<div class="center_headRight">
					<div><span>年级</span>{{userinfo.deptName}}</div>
					<div><span>性别</span>{{userinfo.sex == '1'?'女':'男'}}</div>
				</div>
			</div>
		</div>
		<div class="center_body clearfix">
			<div class="center_navs">
				<div class="center_navItem" v-for="(item,index) in navTabs">
					<div class="center_navItemInfo" @click.stop="changenav(item)" :class="{'active':navTabId == item.id}">
						<img src="@/images/center_navBack.png" class="center_navBack" />
						<img :src="item.iconA" class="center_navIcon center_navIconA" />
						<img :src="item.iconB" class="center_navIcon center_navIconB" />
						<el-badge :value="item.number" :hidden="!item.number">
							<span>{{item.name}}</span>
						</el-badge>
						<i class="el-icon-arrow-down" v-if="item.children"></i>
					</div>
					<el-collapse-transition>
						<div class="center_navItemChildBox" v-show="navTabId==item.id" v-if="item.children">
							<div class="center_navItemChild" @click.stop='changenavchild(it)' :class="{'active':navTabChildrenId == it.id}" v-for="(it,ide) in item.children">
								{{it.name}}
							</div>
						</div>
					</el-collapse-transition>
				</div>
			</div>
			<center-info v-if="navTabId == 'info'"></center-info>
			<center-labstudy v-if="navTabChildrenId == 'labstudy'"></center-labstudy>
			<center-labwork v-if="navTabChildrenId == 'labwork'"></center-labwork>
			<center-coursestudy v-if="navTabChildrenId == 'coursestudy'"></center-coursestudy>
			<center-coursework v-if="navTabChildrenId == 'coursework'"></center-coursework>
			<center-coursenote v-if="navTabChildrenId == 'coursenote'"></center-coursenote>
			<center-exam v-if="navTabId == 'exam'"></center-exam>
			<center-error v-if="navTabId == 'error'"></center-error>
			<center-collect v-if="navTabId == 'collect'"></center-collect>
			<center-stic v-if="navTabId == 'stic'"></center-stic>
			<center-message v-if="navTabId == 'message'"></center-message>
		</div>
	</div>
</template>

<script>
	import { getInfo } from '@/api/user.js'
	import centerInfo from "@/views/center/components/centerInfo.vue"
	import centerLabstudy from "@/views/center/components/centerLabstudy.vue"
	import centerLabwork from "@/views/center/components/centerLabwork.vue"
	import centerCoursestudy from "@/views/center/components/centerCoursestudy.vue"
	import centerCoursework from "@/views/center/components/centerCoursework.vue"
	import centerCoursenote from "@/views/center/components/centerCoursenote.vue"
	import centerExam from "@/views/center/components/centerExam.vue"
	import centerError from "@/views/center/components/centerError.vue"
	import centerCollect from "@/views/center/components/centerCollect.vue"
	import centerStic from "@/views/center/components/centerStic.vue"
	import centerMessage from "@/views/center/components/centerMessage.vue"
	export default {
		components: {
			centerInfo,
			centerLabstudy,
			centerLabwork,
			centerCoursestudy,
			centerCoursework,
			centerCoursenote,
			centerExam,
			centerError,
			centerCollect,
			centerStic,
			centerMessage
		},
		data() {
			return {
				userinfo: {},
				navTabId: 'info',
				navTabChildrenId: '',
				navTabChildrenPid: '',
				navTabs: [{
					name: '基本信息',
					id: 'info',
					iconA: require('@/images/center_infoA.png'),
					iconB: require('@/images/center_info.png'),
				}, {
					name: '我的实验',
					id: 'lab',
					iconA: require('@/images/center_labA.png'),
					iconB: require('@/images/center_lab.png'),
					children: [{
						name: '学习记录',
						id: 'labstudy',
						pid: 'lab',
					}, {
						name: '实验作业',
						id: 'labwork',
						pid: 'lab',
					}]
				}, {
					name: '我的课程',
					id: 'course',
					iconA: require('@/images/center_courseA.png'),
					iconB: require('@/images/center_course.png'),
					children: [{
						name: '课程学习',
						id: 'coursestudy',
						pid: 'course',
					}, {
						name: '课程作业',
						id: 'coursework',
						pid: 'course',
					}, {
						name: '课堂笔记',
						id: 'coursenote',
						pid: 'course',
					}]
				}, {
					name: '我的考试',
					id: 'exam',
					iconA: require('@/images/center_examA.png'),
					iconB: require('@/images/center_exam.png'),
				}, {
					name: '我的错题',
					id: 'error',
					iconA: require('@/images/center_errorA.png'),
					iconB: require('@/images/center_error.png'),
				}, {
					name: '我的收藏',
					id: 'collect',
					iconA: require('@/images/center_collectA.png'),
					iconB: require('@/images/center_collect.png'),
				}, {
					name: '我的统计',
					id: 'stic',
					iconA: require('@/images/center_sticA.png'),
					iconB: require('@/images/center_stic.png'),
				}, {
					name: '我的消息',
					id: 'message',
					iconA: require('@/images/center_messageA.png'),
					iconB: require('@/images/center_message.png'),
					number: 0,
				}],
			};
		},
		created() {
			this.getMyInfo();
			this.getNav();
		},
		methods: {
			getNav() {
				var navTabId = this.$route.query.navTabId;
				var navTabChildrenId = this.$route.query.navTabChildrenId;
				var navTabChildrenPid = this.$route.query.navTabChildrenPid;
				if(navTabId && navTabChildrenId && navTabChildrenPid) {
					this.navTabId = navTabId;
					this.navTabChildrenId = navTabChildrenId;
					this.navTabChildrenPid = navTabChildrenPid;
				}
			},
			changenavchild(it) {
				if(this.navTabChildrenId != it.id) {
					this.navTabChildrenId = it.id
					this.navTabChildrenPid = it.pid
				}
			},
			changenav(item) {
				if(!item.children) {
					this.navTabChildrenId = "";
					this.navTabChildrenPid = "";
					this.navTabId = item.id;
					return
				} else {
					if(this.navTabId != item.id) {
						this.navTabId = item.id;
						if(item.id != this.navTabChildrenPid) {
							this.navTabChildrenId = item.children[0].id;
							this.navTabChildrenPid = item.children[0].pid;
						}
					} else {
						this.navTabId = ''
					}
				}
			},
			getMyInfo() {
				getInfo().then(res => {
					this.userinfo = res.data;
				})
			},
		}
	}
</script>